import { useState, useEffect } from 'react';

export interface Guest {
  id: number;
  name: string;
  hasResponded: boolean;
  attending?: string;
}

interface UseGuestListReturn {
  guests: Guest[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

// Your Google Apps Script Web App URL
const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzHEURpdMDL3Fl25K8WSnU3kogOdwRDHmbS3kiYr9mq_YOi1nyQWMWoClXuCLBj5LZ3/exec';

export const useGuestList = (): UseGuestListReturn => {
  const [guests, setGuests] = useState<Guest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchGuests = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${GOOGLE_SCRIPT_URL}?action=getGuests`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch guest list');
      }

      const data = await response.json();

      if (data.success) {
        setGuests(data.guests);
      } else {
        throw new Error(data.error || 'Failed to load guest list');
      }
    } catch (err) {
      console.error('Error fetching guests:', err);
      setError('Unable to load guest list. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGuests();
  }, []);

  return { guests, loading, error, refetch: fetchGuests };
};
